export default {
      id: "icon--leisure-stretch-usage",
      viewBox: "0 0 50 50",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--leisure-stretch-usage",
      toString: function () {
        return this.url;
      }
    }